import React, {useRef} from "react";
import {arState, cameraState} from "../../state";
import {useSnapshot} from "valtio";
import {Box, OrbitControls} from "@react-three/drei";
import ARController from "../ar/ARController";
import CamaraController from "../camera/CamaraController";
import CamaraPosRecorder from "../camera/CamaraPosRecorder";
import MultiModelLoader from "../loaders/MultiModelLoader";

const ModelsContainer = () => {
  
  const {getGroupVis} = useSnapshot(arState);
  const {developerControlsStatus} = useSnapshot(cameraState);
  
  let group = useRef();
  let recticel = useRef();
  let orbit = useRef();
  
  return (
    <>
      <group ref={group}>
        <group visible={getGroupVis}>
          <MultiModelLoader/>
        </group>
        <Box ref={recticel} args={[0.1, 0.01, 0.1]} visible={!getGroupVis}/>
      </group>
      
      <OrbitControls ref={orbit} makeDefault/>
      {/* <ARController group={group} orbit={orbit}/> */}
      <CamaraController orbit={orbit}/>
      {(developerControlsStatus) && (<CamaraPosRecorder orbit={orbit}/>)}
      
    </>
  )
}

export default ModelsContainer;
